import * as type from '../../../actions/index.types'

const initialState = {
    glLoading: false,
    createLoading: false,
    glAccountsData: null,
    error: null,
};

export function AccountsClosingReducer(state = initialState, action) {

    switch (action.type) {
        // Get GL Accounts Closing
        case type.GET_GL_ACCOUNTS_CLOSING:
            return {
                ...state,
                glLoading: true,
                error: null,
            }
        case type.GET_GL_ACCOUNTS_CLOSING_SUCCESS:
            return {
                ...state,
                error: null,
                glLoading: false,
                glAccountsData: action.payload,
            }
        case type.GET_GL_ACCOUNTS_CLOSING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                glLoading: false,
            }

        // Create Accounts Closing
        case type.CREATE_ACCOUNTS_CLOSING:
            return {
                ...state,
                createLoading: true,
                error: null,
            }
        case type.CREATE_ACCOUNTS_CLOSING_SUCCESS:
            return {
                ...state,
                error: null,
                createLoading: false,
            }
        case type.CREATE_ACCOUNTS_CLOSING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createLoading: false,
            }

        // Clear State
        case type.CLEAR_ACCOUNTS_CLOSING_STATE:
            return initialState;

        default:
            return state
    }
}
